import {useEffect, useState} from 'react'
import BadgeProductsHeader from '../sections/headers/BadgeProductsHeader'
import BadgeProductsTable from '../sections/tables/BadgeProductsTable'
import {BadgeProductsContext} from '../context'
import useBadgeProducts from '../hooks/useBadgeProducts'
import {Pagination} from '../../../utils/pagination'
import useGetBrandsDropdown from '../hooks/useGetBrandsDropdown'
import useGetCategoriesDropdown from '../hooks/useGetCategoriesDropdown'
import useBadgeProductOperations from '../hooks/useBadgeProductOperations'
import usePermission from '../../../hook/usePermission'

interface BadgeProductsProps {
  badgeId: string
}

const BadgeProducts = ({badgeId}: BadgeProductsProps) => {
  const [checkedRows, setCheckedRows] = useState<string[]>([])
  const {
    badgeProducts,
    isLoading,
    filters,
    onSortingChange,
    onChangeBrandFilter,
    onSearch,
    onChangeCategoryFilter,
    onPageChange,
    pagination,
    totalCount,
  } = useBadgeProducts(badgeId)
  const {allBrands, isLoading: isLoadingBrands} = useGetBrandsDropdown(badgeId)
  const {allCategories, isLoading: isLoadingCategories} = useGetCategoriesDropdown()
  const {deleteProductBadge, isOperationLoading} = useBadgeProductOperations()
  const {hasPermission} = usePermission()
  const hasWritePermission = hasPermission('products_product badges', 'write') || false

  useEffect(() => {
    setCheckedRows([])
  }, [isLoading])

  const contextValue = {
    checkedRows,
    setCheckedRows,
    onBrandFilterChange: onChangeBrandFilter,
    onCategoryFilterChange: onChangeCategoryFilter,
    onSearch,
    products: badgeProducts,
    isLoading,
    filters,
    onSortingChange,
    brands: allBrands,
    categories: allCategories,
    isLoadingBrands,
    isLoadingCategories,
    deleteProductBadge,
    isOperationLoading,
    pagination,
    hasWritePermission,
    totalCount,
  }

  return (
    <BadgeProductsContext.Provider value={contextValue}>
      <BadgeProductsHeader />
      <BadgeProductsTable />
      <Pagination pagination={pagination} onPageChange={onPageChange} />
    </BadgeProductsContext.Provider>
  )
}

export default BadgeProducts
